import { createSelector } from 'reselect';

import { CHECKLIST_UPSELLING } from 'constants/ChecklistConstants';
import { getChecklistsByIds, getState as getParent } from 'modules/checklists/selectors/index';

import { getSelectedGroupId } from 'modules/groups/selectors';
import type { RootState } from 'reducers/index';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

const getState = createSelector(getParent, root => root.ui.extrasStats);

const getRoot = (state: RootState): RootState => state;

export const hasMore = createSelector(getState, extras => extras.hasMore);
export const getPage = createSelector(getState, extras => extras.page);
const getIds = createSelector(getState, extras => extras.ids);
export const isLoading = createSelector(getState, extras => extras.loading);
const getError = createSelector(getState, extras => extras.error);

export const hasError = createSelector(getError, Boolean);

export const getList = createSelector(getRoot, getIds, getChecklistsByIds);

export const getParams = createSelector(getPage, getSelectedDealerId, getSelectedGroupId, (page, dealerId, groupId) => ({
  dealerId,
  groupId,
  types: CHECKLIST_UPSELLING,
  page: page.number ?? 0,
  size: page.size ?? 10,
  projection: undefined,
}));
